import type { Snapshot } from '@ember-data/legacy-compat/-private';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import type Store from '@ember-data/store';
import type { ModelSchema } from '@ember-data/store/types';
import ApplicationSerializer from 'lumen/serializers/application';
import type { Breakdown } from 'lumen/utils/central-mapping-constants';

interface MappingCategoryRawResponseMeta {
  breakdown: Breakdown; // Property `breakdown` is not used in the frontend for now, but it's included in the response meta.
}

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class CentralMappingCategorySerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    parent: 'parent_id',
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'data') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('central-mapping/category');
    }

    return key;
  }

  normalizeQueryResponse(
    store: Store,
    primaryModelClass: ModelSchema,
    payload: {
      data: Record<string, unknown>[];
      meta: MappingCategoryRawResponseMeta;
    },
    id: string | number,
    requestType: string,
  ): Record<string, unknown> {
    payload.data.forEach((category) => {
      category['value_type'] = payload.meta.breakdown;
      return category;
    });

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.normalizeQueryResponse(
      store,
      primaryModelClass,
      payload,
      id,
      requestType,
    );
  }

  serialize(
    snapshot: Snapshot,
    options: { isRootCategory: boolean },
  ): Record<string, unknown> {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
    const payload = super.serialize(snapshot, options);

    // In the get hierarchy task, we create a root category on the FE for non-fixed root categories.
    // Here we delete the `parent_id` in the payload of a root category before updating it in the backend.
    if (options.isRootCategory && 'parent_id' in payload) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      delete payload.parent_id;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return payload;
  }
}
